
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersNight as ObiRainShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-night.js';
 
 
 

 
 export const ObiRainShowersNight = createComponent({
   react: React,
   tagName: 'obi-rain-showers-night',
   elementClass: ObiRainShowersNightElement,
   events: {
     
   }
  });
 
 